document.addEventListener('DOMContentLoaded', () => {
  // 🔧 À PERSONNALISER :
  const ATTR_LABEL = 'Nom à broder';              // Le label exact de ton “Attribut de produit”
  const ADDON_HANDLE = 'personnalisation-broderie'; // Handle du produit add-on
  const ADDON_PRICE_TEXT = ' +10,00 €';           // Affichage du prix à côté du label (optionnel)
  const CART_REDIRECT = true;                     // true = aller au panier après ajout

  // Trouve le formulaire produit (Prestige: form[action^="/cart/add"])
  const form = document.querySelector('form[action^="/cart/add"]');
  if (!form) return;

  // Cherche l'input de l’attribut existant par son nom : properties[Nom à broder]
  const attrInput = form.querySelector(`input[name="properties[${ATTR_LABEL}]"], textarea[name="properties[${ATTR_LABEL}]"]`);
  if (!attrInput) return; // si l’attribut n’est pas sur ce produit, on ne fait rien

  // (Optionnel) Affiche le prix près du label
  const labelEl = form.querySelector(`label[for="${attrInput.id}"]`) || attrInput.closest('label');
  if (labelEl && ADDON_PRICE_TEXT) {
    const priceTag = document.createElement('span');
    priceTag.style.marginLeft = '.5rem';
    priceTag.textContent = ADDON_PRICE_TEXT;
    labelEl.appendChild(priceTag);
  }

  // Intercepte la soumission pour chainer les ajouts
  form.addEventListener('submit', async (e) => {
    // Si l'utilisateur clique “Acheter maintenant”, ça contourne parfois le panier → on force notre logique
    e.preventDefault();

    // On clone les données du formulaire (contient déjà properties[Nom à broder])
    const formData = new FormData(form);
    const qty = parseInt(formData.get('quantity') || '1', 10) || 1;
    const value = (formData.get(`properties[${ATTR_LABEL}]`) || '').trim();

    // 1) Ajoute le produit principal
    const mainResp = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });
    if (!mainResp.ok) {
      alert("Impossible d’ajouter le produit. Merci de réessayer.");
      return;
    }

    // 2) Si l’attribut est rempli → ajoute aussi l’add-on payant
    if (value.length > 0) {
      try {
        // Récupère le 1er variant de l’add-on
        const addonData = await fetch(`/products/${ADDON_HANDLE}.js`).then(r => r.json());
        const addonVariantId = addonData?.variants?.[0]?.id;
        if (!addonVariantId) throw new Error('Variant add-on introuvable');

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: addonVariantId,
            quantity: qty,
            properties: {
              "Personnalisation pour": value  // relie l’add-on au texte saisi
            }
          })
        });
      } catch (err) {
        console.error(err);
        alert("Le supplément personnalisation n’a pas pu être ajouté. Le produit principal est dans le panier.");
      }
    }

    // 3) Redirige au panier ou rafraîchis ton mini-panier selon ton flux
    if (CART_REDIRECT) {
      window.location.href = '/cart';
    } else {
      // Si ton thème a un mini-panier AJAX, déclenche son rafraîchissement ici
      // window.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  });

  // (Optionnel) Empêche “Acheter maintenant” de contourner le panier sur ce produit
  const buyNowBtn = form.querySelector('button[name="checkout"]');
  if (buyNowBtn) buyNowBtn.disabled = true;
});
